import { render, staticRenderFns } from "./GameCardImageLink.vue?vue&type=template&id=332dbb97&scoped=true&"
import script from "./GameCardImageLink.vue?vue&type=script&lang=js&"
export * from "./GameCardImageLink.vue?vue&type=script&lang=js&"
import style0 from "./GameCardImageLink.vue?vue&type=style&index=0&id=332dbb97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332dbb97",
  null
  
)

export default component.exports